import React, { useState, useEffect } from "react";
import { Container, Input, Modal, ModalBody, ModalHeader, FormGroup, Label, Col, Row, Button, Table } from "reactstrap";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../share/TabStyle.css'
import { Formik, Form, Field, FieldArray } from "formik";
import { FiEdit } from "react-icons/fi";
import { Loading } from "../../share/loading";
import * as Yup from "yup";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import Swal from 'sweetalert2'
import { RiFileExcel2Line } from 'react-icons/ri'
import { DatePickerInput } from "../../share/DatePickerInput";
import { RenderCustomHeader } from "../../share/RenderCustomHeader";
import { ConvertDateToThaiBuddhist } from "../../share/ConvertDateToThaiBuddhist";
import { ConvertDateFormat } from "../../share/ConvertDateFormat";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import CreateTableComponent from "../../share/CreateTableComponent";
import { AiOutlineFilePdf } from 'react-icons/ai'

import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from '../../share/CustomInputNumeric'

export function InformationForBorrowingDetailComponent() {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    // console.log("data", data);
    // console.log("data", data)
    const [meetingNo, setMeetingNo] = useState("")
    const [meetingYear, setMeetingYear] = useState("")
    const [meetingDate, setMeetingDate] = useState("")
    const [borrowByCompanyNo, setBorrowByCompanyNo] = useState([]); // state array เก็บข้อมูลการขอกู้เดิม
    const [currentBorrowId, setCurrentBorrowId] = useState([]);
    // console.log("currentBorrowId", currentBorrowId);
    const [openModalDetailProposal, setOpenModalDetailProposal] = useState(false)
    const modalDetailProposalToggle = () => setOpenModalDetailProposal(!openModalDetailProposal)
    const [openModalFinancial, setOpenModalFinancial] = useState(false)
    const modalToggleFinancial = () => setOpenModalFinancial(!openModalFinancial)
    const [openModalBorrowByCompanyNo, setOpenModalBorrowByCompanyNo] = useState(false)
    const modalToggleBorrowByCompanyNo = () => setOpenModalBorrowByCompanyNo(!openModalBorrowByCompanyNo)
    const [meetingNoSelect, setMeetingNoSelect] = useState([])
    const [meetingYearSelect, setMeetingYearSelect] = useState([])
    // console.log("meetingNoSelect", meetingNoSelect);


    useEffect(() => {
        async function GetBorrowMeetingApproveTrainTypeData() {
            try {
                let res = await fetch(`api/ProposalBorrow/getProposalSupporting/${meetingNo}/${meetingYear}/${meetingDate}`);
                let resJson = await res.json();
                // console.log(resJson.dataenum)
                setData(resJson.dataenum)
            } catch (e) {
                // console.log("err =>", e)
            }
        }
        GetBorrowMeetingApproveTrainTypeData()
    }, [meetingNo, meetingYear, meetingDate])

    useEffect(() => {
        async function GetMeetingForSelect() {
            setLoading(true)
            try {
                let res = await fetch(`api/ProposalBorrow/getMeetingNoSelect`);
                let resJson = await res.json();
                // console.log(resJson.dataenum)
                setMeetingNoSelect(resJson.dataenum);
                // console.log("borrowInfo", resJson.dataenum);
            } catch (e) {
                // console.log("err =>", e)

            } finally {
                setLoading(false)
            }
        }
        GetMeetingForSelect()

    }, [])

    const formInitialValues = {
        meetingNo: "",
        meetingYear: "",
        meetingDate: "",
    }

    const selectDetailProposalInitalValues = {
        meetingNo: meetingNo,
        meetingYear: meetingYear,
        meetingDate: meetingDate,
        borrowId: currentBorrowId?.borrowId ?? "",
        businessDate: currentBorrowId?.businessDate ?? "",
        creditBureauStatus: currentBorrowId?.creditBureauStatus ?? "",
        checkEmployees: currentBorrowId?.checkEmployees ?? "",
        jobPosition: currentBorrowId?.jobPosition ?? "",
        meetingTime: borrowByCompanyNo.length + 1,
        proposalFinancials: currentBorrowId?.proposalFinancials?.map((item) => (
            {
                proposalFinancialId: item?.proposalFinancialId ?? 0,
                financialBaseYear: item?.financialBaseYear ?? "",
                registeredCapital: item?.registeredCapital ?? "",
                asset: item?.asset ?? "",
                debt: item?.debt ?? "",
                equity: item?.equity ?? "",
                income: item?.income ?? "",
                profitLossNew: item?.profitLossNew ?? "",
                profitLossOld: item?.profitLossOld ?? "",
                auditor: item?.auditor ?? ""
            }
        )),
        borrowByCompanyNoAr: borrowByCompanyNo?.map((item) => (
            {
                borrowId: item?.borrowId ?? "",
                statusBorrow: item?.statusBorrow ?? "",
                followUpResults: item?.followUpResults ?? "",
                visitResults: item?.visitResults ?? "",
                visitResultsDate: item?.visitResultsDate ?? "",
            }
        )),
    }
    const selectDetailProposalValidateSchema = Yup.object().shape({
        businessDate: Yup.date().required(),
        creditBureauStatus: Yup.string().required(),
        checkEmployees: Yup.string().required(),
        jobPosition: Yup.string().required(),
        proposalFinancials: Yup.array().of(
            Yup.object().shape({
                proposalFinancialId: Yup.number().required(),
                financialBaseYear: Yup.string().required("กรุณากรอกปีงบการเงิน"),
                registeredCapital: Yup.string().required("กรุณากรอกทุนจดทะเบียน"),
                asset: Yup.string().required("กรุณากรอกสินทรัพย์รวม"),
                debt: Yup.string().required("กรุณากรอกหนี้สิน"),
                equity: Yup.string().required("กรุณากรอกส่วนของผู้ถือหุ้น"),
                income: Yup.string().required("กรุณากรอกรายได้หลัก"),
                profitLossOld: Yup.string().required("กรุณากรอกกำไร(ขาดทุน)ปีก่อน"),
                profitLossNew: Yup.string().required("กรุณากรอกกำไร(ขาดทุน)ปีปัจจุบัน"),
                auditor: Yup.string().required("กรุณากรอกผู้สอบบัญชี"),
            })
        ),
        // ถ้าต้องการ validate จำนวนจริงให้เป็นตัวเลข >=0 สามารถเปิดคอมเมนต์นี้ได้
        // trainTestCourseResults: Yup.array().of(
        //   Yup.object().shape({
        //     PersonActual: Yup.number().typeError("กรุณากรอกเป็นตัวเลข").min(0, "ต้องมากกว่าหรือเท่ากับ 0")
        //   })
        // )
    })


    const getOldDetailBorrowByCompanyNo = async (borrowId, companyNo) => {
        // console.log("bor", borrowId)
        // console.log("com", companyNo)
        try {
            let res = await fetch(`api/ProposalBorrow/getOldDetailBorrowByCompanyNo/${borrowId}/${companyNo}`)
            let resJson = await res.json();
            setBorrowByCompanyNo(resJson.dataenum)
            // console.log("resJson.dataenum", resJson.dataenum)
        } catch (e) {
            // console.log("err", e)
        }
    }
    const onSubmitDetailProposal = async (values) => {
        setLoading(true)
        try {
            let res = await fetch("api/ProposalBorrow/saveFinancialProposal", {
                method: "POST",
                headers: { 'Content-type': 'application/json' },
                body: JSON.stringify(values)
            })
            let resJson = await res.json();
            if (resJson.status === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ',
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then(() => {
                    modalDetailProposalToggle()
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'บันทึกข้อมูลไม่สำเร็จ',
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                })
            }
        } catch (e) {
            // console.log(e)
        } finally {
            setLoading(false);
        }
    }

    if (loading) { return <Loading /> }
    return (
        <Container>
            <Formik
                initialValues={formInitialValues}
                enableReinitialize
            >
                {({ handleChange, handleBlur, errors, touched }) => {
                    async function getYearForSelect(e) {
                        let postData = new FormData()
                        postData.append("meetingNo", e.target.value)
                        // console.log("meetingNo", e.target.value)
                        try {
                            let res = await fetch("api/ProposalBorrow/getMeetingYearSelect", {
                                method: "POST",
                                body: postData
                            })
                            let resJson = await res.json()
                            // console.log("meeting year",resJson.dataenum)
                            setMeetingYearSelect(resJson.dataenum)
                        } catch (e) {
                            // console.log("err", e)
                        }
                    }
                    return (
                        <Form
                            autoComplete="off"
                        >
                            <div className="row g-3">
                                {/* ครั้งที่ */}
                                <div className="col-12 col-md-3">
                                    <div className="row align-items-center">
                                        <div className="col-4 col-lg-3 text-center text-md-end">
                                            <span>ครั้งที่</span>
                                        </div>
                                        <div className="col-8 col-lg-9">
                                            <Input
                                                name="meetingNo"
                                                type="select"
                                                className="text-center w-100 rounded-pill input-color"
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    setMeetingNo(e.target.value);
                                                    getYearForSelect(e);
                                                }}
                                                onBlur={handleBlur}
                                                value={meetingNo}
                                            >
                                                <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                                                {meetingNoSelect.map((item, k) => (
                                                    <option key={k} value={item.meetingNo}>
                                                        {item.meetingNo}
                                                    </option>
                                                ))}
                                            </Input>
                                        </div>
                                    </div>
                                </div>

                                {/* ปี */}
                                <div className="col-12 col-md-3">
                                    <div className="row align-items-center">
                                        <div className="col-4 col-lg-3 text-center text-md-end">
                                            <span>ปี</span>
                                        </div>
                                        <div className="col-8 col-lg-9">
                                            <Input
                                                name="meetingYear"
                                                type="select"
                                                className="text-center w-100 rounded-pill input-color"
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    setMeetingYear(e.target.value);
                                                }}
                                                value={meetingYear}
                                            >
                                                <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                                                {meetingYearSelect.map((year, i) => (
                                                    <option key={i} value={year.meetingYear}>
                                                        {year.meetingYear}
                                                    </option>
                                                ))}
                                            </Input>
                                        </div>
                                    </div>
                                </div>

                                {/* วันที่ */}
                                <div className="col-12 col-md-3">
                                    <div className="row align-items-center">
                                        <div className="col-4 col-lg-3 text-center text-md-end">
                                            <span>วันที่</span>
                                        </div>
                                        <div className="col-8 col-lg-9">
                                            <Field name="meetingDate">
                                                {({ field, meta, form }) => (
                                                    <DatePicker
                                                        selected={field.value ? new Date(field.value) : null}
                                                        locale="th-buddhist"
                                                        calendarClassName="thai-buddhist"
                                                        dateFormat="dd MMMM yyyy"
                                                        value={ConvertDateToThaiBuddhist(meetingDate ? meetingDate : null)}
                                                        isClearable={true}
                                                        placeholderText="กรุณาเลือก"
                                                        renderCustomHeader={RenderCustomHeader}
                                                        onChange={(date) => {
                                                            form.setFieldValue(field.name, ConvertDateFormat(date));
                                                            setMeetingDate(ConvertDateFormat(date));
                                                        }}
                                                        customInput={
                                                            <Input
                                                                type="text"
                                                                className={`${touched.meetingDate && errors.meetingDate ? "input-error" : ""} rounded-pill text-center input-color w-100`}
                                                                value={ConvertDateToThaiBuddhist(field.value)}
                                                                onChange={() => { }}
                                                                onBlur={field.onBlur}
                                                            />
                                                        }
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                </div>

                                {/* ปุ่ม Export */}
                                <div className="col-12 col-md-3 d-flex align-items-center justify-content-end justify-content-md-end">
                                    <Button className="btn border border-1 mx-1 btn-green" disabled={data.length === 0}
                                        href={`api/ProposalBorrow/exportProposalSupporting/${meetingNo}/${meetingYear}/${meetingDate}`}
                                        download><RiFileExcel2Line />{" "} Export Excel</Button>

                                </div>
                            </div>



                        </Form>
                    )
                }}
            </Formik>
            <Formik
                initialValues={selectDetailProposalInitalValues}
                validationSchema={selectDetailProposalValidateSchema}
                onSubmit={onSubmitDetailProposal}
                enableReinitialize
            >
                {({ values, handleBlur, setFieldValue, errors, handleChange, touched, resetForm, isValid }) => {
                    // console.log("values", values);
                    // console.log("errors", errors);
                    // console.log("isValid", isValid);

                    const onAddDetailProposal = async (borrowId) => {
                        try {
                            let res = await fetch(`api/ProposalBorrow/getCurrentByBorrow/${borrowId}`)
                            let resJson = await res.json();
                            // console.log("data current", resJson.dataenum)
                            setCurrentBorrowId(resJson.dataenum)
                        } catch (e) {
                            // console.log(e)
                        } finally {
                            // setLoading(false)
                            resetForm()
                            modalDetailProposalToggle()
                        }
                    }
                    const COLUMNS = [
                        {
                            Header: "ลำดับ",
                            accessor: (_row, i) => i + 1,
                        },
                        {
                            Header: "ชื่อสถานประกอบกิจการ",
                            accessor: "employee",
                        },
                        {
                            Header: "รายละเอียด",
                            accessor: "borrowId",
                            Cell: ({ row }) => {
                                return (
                                    <div className="text-center">
                                        <button
                                            className="btn border border-1 btn-green"
                                            onClick={() => {
                                                onAddDetailProposal(row.original.borrowId)
                                                getOldDetailBorrowByCompanyNo(row.original.borrowId, row.original.companyNo)
                                            }}>
                                            บันทึก/แก้ไขข้อมูลงบการเงิน
                                        </button>
                                    </div>
                                );
                            },
                        },
                    ]

                    return (
                        <>

                            <CreateTableComponent
                                column={COLUMNS}
                                dataInput={data}
                                showEntrie={false}
                                showPage={true}
                            />
                            <Modal
                                isOpen={openModalDetailProposal}
                                toggle={modalDetailProposalToggle}
                                style={{ maxWidth: "780px", width: "100%" }}
                                className="modal-bordered"
                                backdrop={"static"}
                                keyboard={false}
                            >
                                <ModalHeader className="styled-modal text-center" toggle={modalDetailProposalToggle}>ข้อมูลประกอบการประชุมคณะอนุกรรมการ</ModalHeader>
                                <ModalBody>
                                    <div>
                                        <Form autoComplete="off">
                                            <div className="p-4">
                                                <Field disable="true" name="id" className="d-none" />

                                                <Label
                                                    className="w-100 text-white text-center"
                                                    style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}
                                                >
                                                    ข้อมูลกิจการ
                                                </Label>
                                                <Label className="my-2">
                                                    ประเภทกิจการ:
                                                    <span className="input-color mx-1">
                                                        {currentBorrowId?.businessType}
                                                    </span>
                                                </Label>
                                                <Field disable={true} name="borrowId" value={currentBorrowId?.borrowId} className="d-none" />

                                                <div className="d-flex">
                                                    <FormGroup className="w-50 mx-1">
                                                        <Label>วันที่จดทะเบียน</Label>
                                                        <Field name="businessDate" component={DatePickerInput} />
                                                    </FormGroup>

                                                    <FormGroup className="w-50 mx-1">
                                                        <Label>สถานะเครดิตบูโร</Label>
                                                        <Field name="creditBureauStatus">
                                                            {({ field, meta, form }) => (
                                                                <Input
                                                                    {...field}
                                                                    type="select"
                                                                    className={touched.creditBureauStatus && errors.creditBureauStatus ?
                                                                        "input-error text-center input-color rounded-pill" :
                                                                        "text-center input-color rounded-pill"}
                                                                >
                                                                    <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                                                                    <option value="ปกติ">ปกติ</option>
                                                                    <option value="ไม่ปกติ">ไม่ปกติ</option>
                                                                    <option value="ไม่พบข้อมูล">ไม่พบข้อมูล</option>
                                                                </Input>
                                                            )}
                                                        </Field>
                                                    </FormGroup>
                                                </div>


                                                <Label
                                                    className="w-100 text-white text-center"
                                                    style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}
                                                >
                                                    ข้อมูลการขอกู้ยืมครั้งนี้
                                                </Label>

                                                <Label className="w-100">
                                                    ครั้งที่:
                                                    <span className="input-color mx-1">
                                                        {borrowByCompanyNo.length + 1}
                                                    </span>
                                                </Label>

                                                <Label className="w-100">
                                                    จำนวนเงินที่ขอกู้:
                                                    <span className="input-color mx-1">
                                                        {NumberWithCommas((currentBorrowId?.amountLimitTrain + currentBorrowId?.amountLimitTest))} บาท
                                                    </span>
                                                </Label>

                                                <Label className="w-100">
                                                    จำนวนลูกจ้าง:
                                                    <span className="input-color mx-1">
                                                        {currentBorrowId?.employeeAmount} คน
                                                    </span>
                                                </Label>

                                                <Tabs>
                                                    <TabList style={{ colot: "3074db" }}>
                                                        <Tab>ข้อมูลการฝึกอบรม</Tab>
                                                        <Tab>ข้อมูลการดำเนินการทดสอบ</Tab>
                                                    </TabList>

                                                    {/* ============== TAB ฝึกอบรม (type = 1) ============== */}
                                                    <TabPanel>
                                                        <Label className="w-100">
                                                            จำนวนหลักสูตร:
                                                            <span className="input-color mx-1">
                                                                {currentBorrowId?.trainCourseAmount} หลักสูตร
                                                            </span>
                                                        </Label>

                                                        <Label className="w-100">
                                                            จำนวนผู้เข้ารับการฝึกอบรม:
                                                            <span className="input-color mx-1">
                                                                {currentBorrowId?.personTrainAmount} คน
                                                            </span>
                                                        </Label>

                                                        <Label className="w-100">
                                                            ค่าใช้จ่ายเฉลี่ยต่อคน:
                                                            <span className="input-color mx-1">
                                                                {NumberWithCommas(
                                                                    Number(currentBorrowId?.amountLimitTrain || 0) && Number(currentBorrowId?.personTrainAmount || 0)
                                                                        ? (Number(currentBorrowId?.amountLimitTrain) / Number(currentBorrowId?.personTrainAmount)).toFixed(2)
                                                                        : "0.00"
                                                                )} บาท
                                                            </span>
                                                        </Label>


                                                    </TabPanel>

                                                    {/* ============== TAB ทดสอบ (type = 2) ============== */}
                                                    <TabPanel>
                                                        <Label className="w-100">
                                                            จำนวนสาขาอาชีพ:
                                                            <span className="input-color mx-1">
                                                                {currentBorrowId?.testLawOccupationAmount ?? "0"} สาขาอาชีพ
                                                            </span>
                                                        </Label>

                                                        <Label className="w-100">
                                                            จำนวนผู้เข้ารับการทดสอบ:
                                                            <span className="input-color mx-1">
                                                                {currentBorrowId?.personTestAmount ?? "0"} คน
                                                            </span>
                                                        </Label>

                                                        <Label className="w-100">
                                                            ค่าใช้จ่ายเฉลี่ยต่อคน:
                                                            <span className="input-color mx-1">
                                                                {Number(currentBorrowId?.amountLimitTest || 0) && Number(currentBorrowId?.personTestAmount || 0)
                                                                    ? NumberWithCommas((Number(currentBorrowId?.amountLimitTest) / Number(currentBorrowId?.personTestAmount)).toFixed(2))
                                                                    : "0"} บาท
                                                            </span>
                                                        </Label>


                                                    </TabPanel>
                                                </Tabs>
                                                {/* <div className="d-flex align-items-center justify-content-center">
                                                <section className="p-1">
                                                    <Label>ข้อมูลการฝึกอบรม</Label>
                                                    
                                                </section>
                                                <section className="p-1">
                                                    <Label>ข้อมูลการดำเนินการทดสอบ</Label>
                                                    
                                                </section>

                                            </div> */}




                                                <Label className="w-100">
                                                    ผู้ค้ำประกัน:
                                                    <span className="input-color mx-1">
                                                        {currentBorrowId?.guaranteeTitle ? currentBorrowId?.guaranteeTitle : "-"} {currentBorrowId?.guaranteeName}
                                                    </span>
                                                </Label>

                                                <Label className="w-100">
                                                    ตำแหน่ง:
                                                    <span className="input-color mx-1">
                                                        {currentBorrowId?.position}
                                                    </span>
                                                </Label>

                                                <FormGroup>
                                                    <Label>ตรวจสอบลูกจ้างตาม สปส.</Label>
                                                    <Field name="checkEmployees">
                                                        {({ field, meta }) => (
                                                            <Input
                                                                {...field}
                                                                type="select"
                                                                className={touched.checkEmployees && errors.checkEmployees ?
                                                                    "input-error text-center input-color rounded-pill w-100" :
                                                                    "text-center input-color w-100 rounded-pill"}
                                                            >
                                                                <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                                                                <option value="มี">มี</option>
                                                                <option value="ไม่มี">ไม่มี</option>
                                                            </Input>
                                                        )}
                                                    </Field>
                                                </FormGroup>

                                                <FormGroup>
                                                    <Label>ข้อมูลตำแหน่งงาน</Label>
                                                    <Field name="jobPosition">
                                                        {({ field, meta }) => (
                                                            <Input
                                                                {...field}
                                                                type="select"
                                                                className={touched.jobPosition && errors.jobPosition ?
                                                                    "input-error text-center input-color rounded-pill w-100" :
                                                                    "text-center input-color rounded-pill w-100"}
                                                            >
                                                                <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                                                                <option value="มี">มี</option>
                                                                <option value="ไม่มี">ไม่มี</option>
                                                            </Input>
                                                        )}
                                                    </Field>
                                                </FormGroup>

                                                {/* ประวัติการกู้ที่ผ่านมา */}
                                                {borrowByCompanyNo.length > 0 ? (
                                                    <>
                                                        <Label
                                                            className="w-100 text-white text-center"
                                                            style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}
                                                        >
                                                            ประวัติการกู้ที่ผ่านมา
                                                            <FiEdit className="mx-3 style-icon"
                                                                onClick={() => { modalToggleBorrowByCompanyNo() }}
                                                            />
                                                        </Label>

                                                        <Modal
                                                            isOpen={openModalBorrowByCompanyNo}
                                                            toggle={modalToggleBorrowByCompanyNo}
                                                            // size="l"
                                                            scrollable
                                                            style={{ maxWidth: "780px", width: "100%" }}
                                                            className="modal-bordered"
                                                            backdrop={"static"}
                                                            keyboard={false}
                                                        >
                                                            <ModalHeader className="styled-modal text-center" toggle={modalToggleBorrowByCompanyNo}>ข้อมูลประวัติการกู้ครั้งที่ผ่านมา</ModalHeader>
                                                            <ModalBody>
                                                                <FieldArray name="borrowByCompanyNoAr">
                                                                    {() => {
                                                                        return (
                                                                            <>
                                                                                {borrowByCompanyNo.map((borrow, k) => (
                                                                                    <div key={k} className="p-4 d-flex justify-content-center align-items-center">
                                                                                        <div className="form-border p-3">
                                                                                            <Label className="w-100">
                                                                                                ขอกู้ครั้งที่:
                                                                                                <span className="input-color mx-1">
                                                                                                    {k + 1}
                                                                                                </span>
                                                                                            </Label>
                                                                                            <Label className="w-100">
                                                                                                จำนวนเงินที่ขอกู้:
                                                                                                <span className="input-color mx-1">
                                                                                                    {NumberWithCommas(borrow.amountLimit)} บาท
                                                                                                </span>
                                                                                            </Label>
                                                                                            <Label className="w-100">
                                                                                                งวดผ่อนชำระ:
                                                                                                <span className="input-color mx-1">
                                                                                                    {borrow.installment} งวด
                                                                                                </span>
                                                                                            </Label>

                                                                                            <div className="d-flex mt-2">
                                                                                                <FormGroup className="w-50 mx-1">
                                                                                                    <Label>สถานะการกู้ยืม</Label>
                                                                                                    <Field name={`borrowByCompanyNoAr[${k}].statusBorrow`}>
                                                                                                        {({ field }) => (
                                                                                                            <Input
                                                                                                                type="text"
                                                                                                                className="text-center input-color rounded-pill"
                                                                                                                {...field}
                                                                                                            />
                                                                                                        )}
                                                                                                    </Field>
                                                                                                </FormGroup>

                                                                                                <FormGroup className="w-50 mx-1">
                                                                                                    <Label>รายงานการติดตามประเมินผล</Label>
                                                                                                    <Field name={`borrowByCompanyNoAr[${k}].followUpResults`}>
                                                                                                        {({ field, form }) => (
                                                                                                            <Input
                                                                                                                type="text"
                                                                                                                className="text-center input-color rounded-pill"
                                                                                                                {...field}
                                                                                                            />
                                                                                                        )}
                                                                                                    </Field>
                                                                                                </FormGroup>
                                                                                            </div>

                                                                                            <div className="d-flex mt-2">
                                                                                                <FormGroup className="w-50 mx-1">
                                                                                                    <Label>ผลตรวจเยี่ยมกิจการ</Label>
                                                                                                    <Field name={`borrowByCompanyNoAr[${k}].visitResults`}>
                                                                                                        {({ field, form }) => (
                                                                                                            <Input
                                                                                                                type="text"
                                                                                                                className="text-center input-color rounded-pill"
                                                                                                                {...field}
                                                                                                            />
                                                                                                        )}
                                                                                                    </Field>
                                                                                                </FormGroup>

                                                                                                <FormGroup className="w-50 mx-1">
                                                                                                    <Label>วันที่ตรวจเยี่ยมกิจการ</Label>
                                                                                                    <Field name={`borrowByCompanyNoAr[${k}].visitResultsDate`} component={DatePickerInput} />
                                                                                                </FormGroup>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </>
                                                                        )
                                                                    }}

                                                                </FieldArray>
                                                                <div className="d-flex justify-content-center mb-4">
                                                                    <button type="button" className="btn-blue w-25" onClick={() => { modalToggleBorrowByCompanyNo() }}>บันทึก</button>
                                                                </div>
                                                            </ModalBody>





                                                        </Modal>

                                                    </>


                                                ) : null}

                                                {/* financial form */}
                                                <Label
                                                    className="w-100 text-white text-center"
                                                    style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}
                                                >
                                                    กรอกข้อมูลฐานะทางการเงิน
                                                    <FiEdit
                                                        className="mx-3 style-icon"
                                                        onClick={() => { modalToggleFinancial() }}
                                                    />
                                                </Label>

                                                {/* กรอกรายละเอียดงบการเงิน */}
                                                {/* <Modal
                                                    isOpen={openModalFinancial}
                                                    toggle={modalToggleFinancial}
                                                    size="l"
                                                    scrollable
                                                    className="modal-bordered"
                                                    backdrop={"static"}
                                                    keyboard={false}
                                                >
                                                    <ModalHeader className="styled-modal text-center" toggle={modalToggleFinancial}>ข้อมูลฐานะทางการเงิน</ModalHeader>
                                                    <ModalBody>
                                                        <FormGroup className="mb-2">
                                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                                <Label>ปีงบการเงิน</Label>
                                                            </div>
                                                        </FormGroup>
                                                        <Field name={`financialBaseYear`}>
                                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                                <NumericFormat
                                                                    {...field}
                                                                    maxLength={4}
                                                                    isNumericString={true}
                                                                    displayType="number"
                                                                    customInput={CustomInputNumeric}
                                                                    onValueChange={(values) => {
                                                                        setFieldValue(field.name, values.value)
                                                                    }}
                                                                    className={meta.error && meta.touched ? "input-error" : ""}
                                                                />

                                                            )}

                                                        </Field>
                                                        <FormGroup className="mt-3">
                                                            <Label>ทุนจดทะเบียน</Label>
                                                            <Field name={`registeredCapital`} >
                                                                {({ field, meta, form: { setFieldValue, values } }) => (
                                                                    <NumericFormat
                                                                        {...field}
                                                                        // maxLength={}
                                                                        isNumericString={true}
                                                                        displayType="number"
                                                                        thousandSeparator=","
                                                                        decimalScale={2}
                                                                        customInput={CustomInputNumeric}
                                                                        onValueChange={(values) => {
                                                                            setFieldValue(field.name, values.value)
                                                                        }}
                                                                        className={meta.error && meta.touched ? "input-error" : ""}
                                                                    />

                                                                )}
                                                            </Field>
                                                        </FormGroup>
                                                        <div className="d-flex">
                                                            <FormGroup className="mx-3">
                                                                <Label>สินทรัพย์รวม</Label>
                                                                <Field name={`asset`}>
                                                                    {({ field, meta, form: { setFieldValue, values } }) => (
                                                                        <NumericFormat
                                                                            {...field}
                                                                            // maxLength={}
                                                                            isNumericString={true}
                                                                            thousandSeparator=","
                                                                            decimalScale={2}
                                                                            displayType="number"
                                                                            customInput={CustomInputNumeric}
                                                                            onValueChange={(values) => {
                                                                                setFieldValue(field.name, values.value)
                                                                            }}
                                                                            className={meta.error && meta.touched ? "input-error" : ""}
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </FormGroup>
                                                            <FormGroup className="mx-3">
                                                                <Label>หนี้สิน</Label>
                                                                <Field name={`debt`}>
                                                                    {({ field, meta, form: { setFieldValue, values } }) => (
                                                                        <NumericFormat
                                                                            {...field}
                                                                            // maxLength={}
                                                                            isNumericString={true}
                                                                            thousandSeparator=","
                                                                            decimalScale={2}
                                                                            displayType="number"
                                                                            customInput={CustomInputNumeric}
                                                                            onValueChange={(values) => {
                                                                                setFieldValue(field.name, values.value)
                                                                            }}
                                                                            className={meta.error && meta.touched ? "input-error" : ""}
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </FormGroup>

                                                        </div>
                                                        <div className="d-flex">
                                                            <FormGroup className="mx-3">
                                                                <Label>ส่วนของผู้ถือหุ้น</Label>
                                                                <Field name={`equity`}>
                                                                    {({ field, meta, form: { setFieldValue, values } }) => (
                                                                        <NumericFormat
                                                                            {...field}
                                                                            // maxLength={}
                                                                            isNumericString={true}
                                                                            thousandSeparator=","
                                                                            decimalScale={2}
                                                                            displayType="number"
                                                                            customInput={CustomInputNumeric}
                                                                            onValueChange={(values) => {
                                                                                setFieldValue(field.name, values.value)
                                                                            }}
                                                                            className={meta.error && meta.touched ? "input-error" : ""}
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </FormGroup>
                                                            <FormGroup className="mx-3">
                                                                <Label>รายได้หลัก</Label>
                                                                <Field name={`income`}>
                                                                    {({ field, meta, form: { setFieldValue, values } }) => (
                                                                        <NumericFormat
                                                                            {...field}
                                                                            // maxLength={}
                                                                            isNumericString={true}
                                                                            thousandSeparator=","
                                                                            decimalScale={2}
                                                                            displayType="number"
                                                                            customInput={CustomInputNumeric}
                                                                            onValueChange={(values) => {
                                                                                setFieldValue(field.name, values.value)
                                                                            }}
                                                                            className={meta.error && meta.touched ? "input-error" : ""}
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </FormGroup>


                                                        </div>
                                                        <div className="d-flex">
                                                            <FormGroup className="mx-3">
                                                                <Label>กำไร (ขาดทุน) ปีก่อน</Label>
                                                                <Field name={`profitLossOld`}>
                                                                    {({ field, meta, form: { setFieldValue, values } }) => (
                                                                        <NumericFormat
                                                                            {...field}
                                                                            // maxLength={}
                                                                            isNumericString={true}
                                                                            thousandSeparator=","
                                                                            decimalScale={2}
                                                                            displayType="number"
                                                                            customInput={CustomInputNumeric}
                                                                            onValueChange={(values) => {
                                                                                setFieldValue(field.name, values.value)
                                                                            }}
                                                                            className={meta.error && meta.touched ? "input-error" : ""}
                                                                        />
                                                                    )}

                                                                </Field>
                                                            </FormGroup>
                                                            <FormGroup className="mx-3">
                                                                <Label>กำไร (ขาดทุน) ปีปัจจุบัน</Label>
                                                                <Field name={`profitLossNew`}>
                                                                    {({ field, meta, form: { setFieldValue, values } }) => (
                                                                        <NumericFormat
                                                                            {...field}
                                                                            // maxLength={}
                                                                            isNumericString={true}
                                                                            thousandSeparator=","
                                                                            decimalScale={2}
                                                                            displayType="number"
                                                                            customInput={CustomInputNumeric}
                                                                            onValueChange={(values) => {
                                                                                setFieldValue(field.name, values.value)
                                                                            }}
                                                                            className={meta.error && meta.touched ? "input-error" : ""}
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </FormGroup>
                                                        </div>
                                                        <FormGroup>
                                                            <Label>ผู้สอบบัญชี</Label>
                                                            <Field name={`auditor`}>
                                                                {({ field, form, meta }) => (
                                                                    <Input
                                                                        type="text"
                                                                        className={`input-color rounded-pill text-center ${meta.error && meta.touched ? "input-error" : ""}`}
                                                                        {...field}
                                                                    />
                                                                )}
                                                            </Field>
                                                        </FormGroup>

                                                        <div className="d-flex justify-content-center">
                                                            <button
                                                                type="button"
                                                                className="btn-blue w-25"
                                                                disabled={!isValid}
                                                                onClick={() => {
                                                                    modalToggleFinancial(!openModalFinancial)
                                                                }}
                                                            >
                                                                ตกลง
                                                            </button>
                                                        </div>
                                                    </ModalBody>
                                                </Modal> */}
                                                <Modal
                                                    isOpen={openModalFinancial}
                                                    toggle={modalToggleFinancial}
                                                    size="xl"
                                                    scrollable
                                                    className="modal-bordered"
                                                    backdrop={"static"}
                                                    keyboard={false}
                                                >
                                                    <ModalHeader className="styled-modal text-center" toggle={modalToggleFinancial}>
                                                        ข้อมูลฐานะทางการเงิน
                                                    </ModalHeader>
                                                    <ModalBody>
                                                        <FieldArray name={'proposalFinancials'}>
                                                            {({ push, remove, form }) => {
                                                                const items = form.values.proposalFinancials || [];
                                                                // const canAdd = items.length < 2;

                                                                return (
                                                                    <>
                                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                                            <Label className="m-0">เพิ่มข้อมูลปีงบการเงิน (สูงสุด 2 ปี)</Label>
                                                                            {/* คงไว้ตามที่คอมเมนต์ไว้ ห้ามเปิดคอมเมนต์ */}
                                                                            {/* <button
                    type="button"
                    className="btn-blue"
                    disabled={!canAdd}
                    onClick={() =>
                      push({
                        financialBaseYear: "",
                        registeredCapital: "",
                        asset: "",
                        debt: "",
                        equity: "",
                        income: "",
                        profitLossOld: "",
                        profitLossNew: "",
                        auditor: "",
                      })
                    }
                  >
                    + เพิ่มปี
                  </button> */}
                                                                        </div>

                                                                        {/* ===== Layout ปรับใหม่ ===== */}
                                                                        {/* 1) การ์ด (ปี) วาง 2 คอลัมน์บนจอใหญ่ / 1 คอลัมน์บนจอเล็ก */}
                                                                        <Row className="g-3">
                                                                            {items.map((_, index) => (
                                                                                <Col key={index} xs="12" lg="6">
                                                                                    <div className="form-border p-3 h-100 d-flex flex-column">
                                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                                            <Label className="m-0 fw-bold">ปีที่ {index + 1}</Label>
                                                                                            {/* {items.length > 1 && (
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="border border-1 btn-red"
                                                                                                    onClick={() => remove(index)}
                                                                                                >
                                                                                                    ลบปีนี้
                                                                                                </button>
                                                                                            )} */}
                                                                                        </div>

                                                                                        {/* 2) ฟิลด์ด้านในจัดเป็น Grid 2 คอลัมน์ เพื่อกรอกง่าย มองง่าย */}
                                                                                        <div className="mt-3">
                                                                                            {/* ปีงบการเงิน */}
                                                                                            <FormGroup className="mb-3">
                                                                                                <Label>ปีงบการเงิน</Label>
                                                                                                <Field name={`proposalFinancials[${index}].financialBaseYear`}>
                                                                                                    {({ field, meta, form: { setFieldValue } }) => (
                                                                                                        <NumericFormat
                                                                                                            {...field}
                                                                                                            maxLength={4}
                                                                                                            isNumericString
                                                                                                            displayType="number"
                                                                                                            customInput={CustomInputNumeric}
                                                                                                            onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                                                                            className={`text-center ${meta.error && meta.touched ? "input-error" : ""}`}
                                                                                                            placeholder="เช่น 2567"
                                                                                                        />
                                                                                                    )}
                                                                                                </Field>
                                                                                            </FormGroup>

                                                                                            <Row className="g-3">
                                                                                                <Col xs="12" md="6">
                                                                                                    {/* ทุนจดทะเบียน */}
                                                                                                    <FormGroup>
                                                                                                        <Label>ทุนจดทะเบียน</Label>
                                                                                                        <Field name={`proposalFinancials[${index}].registeredCapital`}>
                                                                                                            {({ field, meta, form: { setFieldValue } }) => (
                                                                                                                <NumericFormat
                                                                                                                    {...field}
                                                                                                                    isNumericString
                                                                                                                    thousandSeparator=","
                                                                                                                    decimalScale={2}
                                                                                                                    displayType="number"
                                                                                                                    customInput={CustomInputNumeric}
                                                                                                                    onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                                                                                    className={`${meta.error && meta.touched ? "input-error" : ""}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        </Field>
                                                                                                    </FormGroup>
                                                                                                </Col>

                                                                                                <Col xs="12" md="6">
                                                                                                    {/* สินทรัพย์รวม */}
                                                                                                    <FormGroup>
                                                                                                        <Label>สินทรัพย์รวม</Label>
                                                                                                        <Field name={`proposalFinancials[${index}].asset`}>
                                                                                                            {({ field, meta, form: { setFieldValue } }) => (
                                                                                                                <NumericFormat
                                                                                                                    {...field}
                                                                                                                    isNumericString
                                                                                                                    thousandSeparator=","
                                                                                                                    decimalScale={2}
                                                                                                                    displayType="number"
                                                                                                                    customInput={CustomInputNumeric}
                                                                                                                    onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                                                                                    className={`${meta.error && meta.touched ? "input-error" : ""}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        </Field>
                                                                                                    </FormGroup>
                                                                                                </Col>

                                                                                                <Col xs="12" md="6">
                                                                                                    {/* หนี้สิน */}
                                                                                                    <FormGroup>
                                                                                                        <Label>หนี้สิน</Label>
                                                                                                        <Field name={`proposalFinancials[${index}].debt`}>
                                                                                                            {({ field, meta, form: { setFieldValue } }) => (
                                                                                                                <NumericFormat
                                                                                                                    {...field}
                                                                                                                    isNumericString
                                                                                                                    thousandSeparator=","
                                                                                                                    decimalScale={2}
                                                                                                                    displayType="number"
                                                                                                                    customInput={CustomInputNumeric}
                                                                                                                    onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                                                                                    className={`${meta.error && meta.touched ? "input-error" : ""}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        </Field>
                                                                                                    </FormGroup>
                                                                                                </Col>

                                                                                                <Col xs="12" md="6">
                                                                                                    {/* ส่วนของผู้ถือหุ้น */}
                                                                                                    <FormGroup>
                                                                                                        <Label>ส่วนของผู้ถือหุ้น</Label>
                                                                                                        <Field name={`proposalFinancials[${index}].equity`}>
                                                                                                            {({ field, meta, form: { setFieldValue } }) => (
                                                                                                                <NumericFormat
                                                                                                                    {...field}
                                                                                                                    isNumericString
                                                                                                                    thousandSeparator=","
                                                                                                                    decimalScale={2}
                                                                                                                    displayType="number"
                                                                                                                    customInput={CustomInputNumeric}
                                                                                                                    onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                                                                                    className={`${meta.error && meta.touched ? "input-error" : ""}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        </Field>
                                                                                                    </FormGroup>
                                                                                                </Col>

                                                                                                <Col xs="12" md="6">
                                                                                                    {/* รายได้หลัก */}
                                                                                                    <FormGroup>
                                                                                                        <Label>รายได้หลัก</Label>
                                                                                                        <Field name={`proposalFinancials[${index}].income`}>
                                                                                                            {({ field, meta, form: { setFieldValue } }) => (
                                                                                                                <NumericFormat
                                                                                                                    {...field}
                                                                                                                    isNumericString
                                                                                                                    thousandSeparator=","
                                                                                                                    decimalScale={2}
                                                                                                                    displayType="number"
                                                                                                                    customInput={CustomInputNumeric}
                                                                                                                    onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                                                                                    className={`${meta.error && meta.touched ? "input-error" : ""}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        </Field>
                                                                                                    </FormGroup>
                                                                                                </Col>

                                                                                                <Col xs="12" md="6">
                                                                                                    {/* กำไร (ขาดทุน) ปีก่อน */}
                                                                                                    <FormGroup>
                                                                                                        <Label>กำไร (ขาดทุน) ปีก่อน</Label>
                                                                                                        <Field name={`proposalFinancials[${index}].profitLossOld`}>
                                                                                                            {({ field, meta, form: { setFieldValue } }) => (
                                                                                                                <NumericFormat
                                                                                                                    {...field}
                                                                                                                    isNumericString
                                                                                                                    thousandSeparator=","
                                                                                                                    decimalScale={2}
                                                                                                                    displayType="number"
                                                                                                                    customInput={CustomInputNumeric}
                                                                                                                    onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                                                                                    className={`${meta.error && meta.touched ? "input-error" : ""}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        </Field>
                                                                                                    </FormGroup>
                                                                                                </Col>

                                                                                                <Col xs="12" md="6">
                                                                                                    {/* กำไร (ขาดทุน) ปีปัจจุบัน */}
                                                                                                    <FormGroup>
                                                                                                        <Label>กำไร (ขาดทุน) ปีปัจจุบัน</Label>
                                                                                                        <Field name={`proposalFinancials[${index}].profitLossNew`}>
                                                                                                            {({ field, meta, form: { setFieldValue } }) => (
                                                                                                                <NumericFormat
                                                                                                                    {...field}
                                                                                                                    isNumericString
                                                                                                                    thousandSeparator=","
                                                                                                                    decimalScale={2}
                                                                                                                    displayType="number"
                                                                                                                    customInput={CustomInputNumeric}
                                                                                                                    onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                                                                                    className={`${meta.error && meta.touched ? "input-error" : ""}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        </Field>
                                                                                                    </FormGroup>
                                                                                                </Col>
                                                                                            </Row>

                                                                                            {/* ผู้สอบบัญชี */}
                                                                                            <FormGroup className="mt-2">
                                                                                                <Label>ผู้สอบบัญชี</Label>
                                                                                                <Field name={`proposalFinancials[${index}].auditor`}>
                                                                                                    {({ field, meta }) => (
                                                                                                        <Input
                                                                                                            type="text"
                                                                                                            className={`input-color rounded-pill text-center ${meta.error && meta.touched ? "input-error" : ""}`}
                                                                                                            {...field}
                                                                                                            placeholder="ชื่อผู้สอบบัญชี"
                                                                                                        />
                                                                                                    )}
                                                                                                </Field>
                                                                                            </FormGroup>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                            ))}
                                                                        </Row>

                                                                        {/* ปุ่มยืนยัน คงไว้เหมือนเดิม แค่จัดให้อยู่กลาง */}
                                                                        <div className="d-flex justify-content-center mt-3">
                                                                            <button
                                                                                type="button"
                                                                                className="btn-blue w-25"
                                                                                disabled={errors.proposalFinancials}
                                                                                onClick={() => modalToggleFinancial(!openModalFinancial)}
                                                                            >
                                                                                ตกลง
                                                                            </button>
                                                                        </div>
                                                                    </>
                                                                );
                                                            }}
                                                        </FieldArray>
                                                    </ModalBody>
                                                </Modal>


                                            </div>
                                            <FormGroup className="d-flex justify-content-center align-items-center">
                                                <button disabled={!isValid} type="submit" className="btn-blue w-50">บันทึก</button>
                                            </FormGroup>

                                        </Form>
                                    </div>
                                </ModalBody>
                            </Modal>
                        </>
                    )
                }}
            </Formik>
        </Container>
    )
}
